import React from 'react'
import DataGridWithSearch from './DataGridWithSearch'

const getColumns = () => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
  },
  {
    field: 'wip',
    headerName: 'WIP',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.wipFormatted,
    flex: 1,
  },
  {
    field: 'finishedGoods',
    headerName: 'Finished Goods',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.finishedGoodsFormatted,
    flex: 1,
  },
  {
    field: 'averageCost',
    headerName: 'Avg Cost',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.averageCostFormatted,
    flex: 1,
  },
  {
    field: 'value',
    headerName: 'Value',
    headerAlign: 'right',
    align: 'right',
    renderCell: params => params?.row?.valueFormatted,
    flex: 1,
  },
]

const InventoryCommodityMaterialGrid = props => <DataGridWithSearch {...props} columns={getColumns()} />

InventoryCommodityMaterialGrid.propTypes = DataGridWithSearch.propTypes

InventoryCommodityMaterialGrid.defaultProps = DataGridWithSearch.defaultProps

export default InventoryCommodityMaterialGrid
